<template>
  <div class="order-applicants">
    <div
      class="order-applicant-list"
      v-for="(item, app_index) in applicantList"
      :key="item.order_applicant_id"
    >
      <div class="applicant-li-info">
        <div class="applicant-name">{{ item.applicant_name }}</div>
        <div class="applicant-identity">{{ item.identity_id }}</div>
        <div class="applicant-status">
          {{ APPLICANT_STATUS_MAP[item.status] }}
        </div>
      </div>
      <div class="applicant-li-reject" v-if="item.status === 2">
        <div class="reject-handle">
          <div class="reject-name">
            <img
              src="../../../../../../../../assets/imgs/work-wx/customer/icon-notice.png"
              alt=""
            />
            <div class="reject-notice">{{ item.applicant_name }}预审不通过</div>
          </div>
        </div>
        <div class="reject-reason" v-if="item.memo && item.memo.length > 0">
          <div class="reject-reason-text">
            {{ getRejectReason(item.memo) }}
          </div>
          <div class="reject-reason-copy" @click="copyRejectReason(item)">
            <img
              src="../../../../../../../../assets/imgs/work-wx/customer/icon-copy.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 列表最后一个不展示 -->
      <div
        class="line-dashed"
        v-if="app_index !== applicantList.length - 1 && item.status !== 2"
      ></div>
    </div>
  </div>
</template>

<script>
import { APPLICANT_STATUS_MAP } from '@/pages/work-wx/consts/order-const.js';

export default {
  props: {
    applicantList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      APPLICANT_STATUS_MAP,
    };
  },
  methods: {
    // 处理下拒绝原因
    getRejectReason(memo) {
      if (memo && memo.length > 0) {
        memo = memo
          .map(
            (item, index) =>
              `${index + 1}、${item.material_name}：${item.memo}`,
          )
          .join('；');
      }
      return memo;
    },
    // 复制错误原因
    copyRejectReason(applicant) {
      const firstLine = `${applicant.applicant_name}预审不通过；\n`;
      let copyText;
      if (applicant.memo && applicant.memo.length > 0) {
        copyText =
          firstLine +
          applicant.memo
            .map(
              (item, index) =>
                `${index + 1}、${item.material_name}：${item.memo}`,
            )
            .join('\n');
      }
      ww.setClipboardData({
        data: copyText,
        success() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 申请人信息
.order-applicants {
  display: flex;
  flex-direction: column;
  padding: 0 15px 10px;
  .order-applicant-list {
    margin-top: 15px;
    .applicant-li-info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .applicant-name {
        width: 80px;
        font-size: 12px;
        color: #2c3344;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .applicant-identity,
      .applicant-status {
        margin-left: 20px;
        color: #717785;
        font-size: 12px;
      }
      .applicant-identity {
        width: 70px;
      }
      .applicant-status {
        width: 100px;
      }
    }
    .applicant-li-reject {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      .reject-handle {
        display: flex;
        justify-content: space-between;
        min-height: 26px;
        line-height: 26px;
        background: rgba(242, 80, 96, 0.15);
        border-radius: 1px 1px 0px 0px;
        margin: 10px 0 0 0;
        padding: 0 8px;
        .reject-name {
          display: flex;
          flex: 1;
          margin-right: 10px;
          > img {
            display: block;
            width: 14px;
            height: 14px;
            margin: 5px 6px 0 0;
          }
          .reject-notice {
            font-size: 12px;
            color: #f25060;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 46%;
          }
        }
      }

      .reject-reason {
        display: flex;
        width: 100%;
        height: auto;
        background: rgba(237, 237, 237, 0.45);
        .reject-reason-text {
          font-size: 12px;
          color: #2c3344;
          line-height: 25px;
          white-space: normal;
          word-break: break-all;
          flex: 1;
          padding: 4px 0 8px 6px;
        }
        .reject-reason-copy {
          width: 50px;
          height: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          > img {
            width: 20px;
            height: 20px;
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .line-dashed {
      border-bottom: 1px dashed #dee3f0;
      margin: 10px 0 0;
    }
  }
}
</style>
